import BokalSourage from 'bokal-sourage';

export default new BokalSourage('ohm__');
